import React, { useState, useEffect, useRef } from 'react';
import cx from 'classnames';
import moment from 'moment';

import { Overlay } from './../../../UIComponents';
//import ClientProfile from './../../ClientProfile';
import Loading from './../../../common/Loading';
import ProfileInfo from './ProfileInfo';
import AppointmentInfo from './AppointmentInfo';

import helpers from './../../../Conversations/helpers';

import './index.scss';

const stopPropagation = {
  onClick: (e) => e.stopPropagation(),
};

const ScheduleDetails = ({
  selectedSchedule,
  visibility,
  onClose,
  business,
  auth,
  getClientDetails,
  conversations,
  getNameFromId,
}) => {
  console.log('conversations', conversations);
  const selectedClientId = selectedSchedule?.slotdata?.user_id
    ? selectedSchedule.slotdata.user_id
    : null;
  const [selectedClient, setClient] = useState(selectedClientId);
  const bzid = business.id || auth.studio_id;

  useEffect(() => {
    if (selectedClientId) {
      setClient(selectedClientId);
    }
  }, [selectedClientId]);

  useEffect(() => {
    if (selectedClient) {
      getClientDetails({
        businessId: bzid,
        clients: [selectedClient],
      });
    }
  }, [selectedClient]);

  const wrapperRef = useRef(null);
  const dropdownRef = useRef(null);
  useOutsideAlerter(wrapperRef, dropdownRef);
  function useOutsideAlerter(ref, dropdownRef) {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {}

    useEffect(() => {
      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside);
      };
    });
  }

  return (
    <div className={cx('pane-container', { open: visibility })}>
      <Overlay onOverlayClick={onClose} style={{ zIndex: 100 }}>
        <div className="pane details-pane" {...stopPropagation}>
          <header className="pane__header header">
            <div className="header__info">
              <h4 className="header__info__name">{selectedSchedule.title}</h4>
              <p className={cx('header__info__phone')}></p>
              <a
                href=""
                onClick={(e) => {
                  e.preventDefault();
                  onClose();
                }}
                className="header__info__close"
              >
                &times;
              </a>
            </div>
          </header>
          <div className="pane__content">
            {conversations.getClientsDetails ? (
              <div className="tabs-content">
                <div className="tabs-content__loader">
                  <Loading />
                </div>
              </div>
            ) : (
              <div className="tabs-content">
                <ProfileInfo
                  selectedSchedule={selectedSchedule}
                  details={conversations.clientsDetails}
                />
                <AppointmentInfo
                  selectedSchedule={selectedSchedule}
                  details={conversations.clientsDetails}
                  getNameFromId={getNameFromId}
                />
              </div>
            )}
          </div>
        </div>
      </Overlay>
    </div>
  );
};

export default ScheduleDetails;
